import { useUserStore } from "@/stores/UserStore";

export const usePermissions = () => {
  const userStore = useUserStore();

  const can = (key: string) => {
    const user = userStore.currentUser;
    if (!user) return false;
    return user.permissions.map((p) => p.name).includes(key);
  };

  const hasProduct = (product: string) => {
    const user = userStore.currentUser;
    if (!user) return false;

    let permissions = user.permissions.map((p) => p.name);
    if (userStore.currentAppClient) {
      permissions = (user.products ?? []).map((p) => p.name);
    } else if (product === "audience_activation") {
      // TODO: remove this when new permissions are live. this is new permission being introduced
      return true;
    }

    return permissions?.includes(product);
  };

  const hasRole = (role: string) => {
    const user = userStore.currentUser;
    if (!user) return false;
    return user.roles.some((r) => r.name === role);
  };

  return { can, hasProduct, hasRole };
};
